import { render, staticRenderFns } from "./Yunjiancha.vue?vue&type=template&id=70cee864&scoped=true&"
import script from "./Yunjiancha.vue?vue&type=script&lang=js&"
export * from "./Yunjiancha.vue?vue&type=script&lang=js&"
import style0 from "./Yunjiancha.vue?vue&type=style&index=0&id=70cee864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cee864",
  null
  
)

component.options.__file = "Yunjiancha.vue"
export default component.exports